<button
  pButton
  type="button"
  icon="pi pi-download"
  label="Potvrdi ispis naljepnice"
  (click)="printLabelSpremistePdf()"
></button>

